import { render, staticRenderFns } from "./AutoContainer.vue?vue&type=template&id=b25b4ed4"
import script from "./AutoContainer.vue?vue&type=script&lang=ts"
export * from "./AutoContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports